/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/no-array-index-key */
import React, { useCallback, useState, useEffect, useRef } from "react";
import { Card, Typography, CircularProgress } from "@mui/material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
// import CustomTextField from "../textField";
// import { divStyle, spanStyle, arrowDropDown, card, typography } from "./styles";
import Styles from "./styles";
import InputField from "../common/new/InputField/InputField";

export default function CustomAutoComplete({
  options = [],
  selectedValue,
  optionLabelId,
  disabled,
  isServerSide,
  api,
  withParam,
  value,
  isAddress,
  optionValueId,
  getSelectedValue,
  formatter,
  valueOnDisabled,
  ...props
}) {
  const [search, setSearch] = useState([]);
  const [selected, setSelected] = useState("");
  const [searchVal, setsearchVal] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const ref = useRef(null);

  useEffect(() => {
    if (options.length > 0) {
      setSearch(options);
    }
    setIsOpen(false);
  }, [options]);

  const debounce = (func) => {
    let timer;

    // eslint-disable-next-line func-names
    return function (...args) {
      const context = this;

      if (timer) clearTimeout(timer);

      timer = setTimeout(() => {
        timer = null;
        func.apply(context, args);
      }, 500);
    };
  };

  useEffect(() => {
    if (value && search.length) {
      const d = search.filter((o) => {
        return String(o[optionValueId]) === String(value);
      });
      if (d.length > 0) {
        if (formatter) {
          setSelected(formatter(d[0][optionLabelId]));
        } else {
          setSelected(d[0][optionLabelId]);
        }
        if (getSelectedValue && selectedValue) {
          selectedValue(d[0]);
        }
      }
    } else if (!isAddress) {
      setSelected("");
    }
  }, [value, search]);

  const getData = async (v) => {
    setIsLoading(true);
    const response = await api({ data: { [withParam]: v } });
    setIsLoading(false);
    if (!isOpen) {
      setIsOpen(true);
    }
    setSearch(response.data || response || []);
  };
  const handleSearch = (evt) => {
    const val = evt.target.value;
    if (!evt.target.value) {
      selectedValue("");
      return;
    }
    setsearchVal(val);
    if (isServerSide && val.length >= 3) {
      getData(val);
    }
    if (!isOpen) {
      setIsOpen(true);
    }
  };

  const handleChange = useCallback(debounce(handleSearch), []);
  const handleClick = () => {
    setIsOpen(true);
  };
  const handleClose = () => {
    setIsOpen(false);
  };

  let listData = search;
  if (!isServerSide) {
    listData = search.filter((s) => {
      return s[optionLabelId]
        .toLowerCase()
        .includes(searchVal?.toLocaleLowerCase() || "");
    });
  }

  const handleClickOutside = (event) => {
    if (ref.current && !ref.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  }, []);

  return (
    <div style={Styles.container} ref={ref}>
      <InputField
        type="text"
        fullWidth
        defaultValue={valueOnDisabled || selected || searchVal}
        key={selected}
        name="search"
        onChange={handleChange}
        onFocus={() => {
          setIsOpen(true);
        }}
        onClick={() => {
          handleClick();
        }}
        disabled={disabled}
        // value={valueOnDisabled || selected || searchVal}
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...props}
      />
      <span style={Styles.dropDownIcon}>
        {isLoading ? (
          <CircularProgress size={16} />
        ) : (
          <ArrowDropDownIcon fontSize="large" style={Styles.arrowDropDown} />
        )}
      </span>
      {search?.length > 0 && isOpen && (
        <Card style={Styles.card}>
          {listData.map((item, i) => (
            <Typography
              key={i}
              onClick={() => {
                if (isAddress) {
                  setSelected(
                    `${item.query}   Area: ${item.areaName}, Zone: ${item.zoneName}`
                  );
                } else if (formatter) {
                  setSelected(formatter(item[optionLabelId]));
                } else if (optionLabelId) {
                  setSelected(item[optionLabelId]);
                } else {
                  setSelected(item);
                }
                selectedValue(item);
                setsearchVal("");
                handleClose();
              }}
              style={Styles.typography}
            >
              {isAddress ? (
                <>
                  <span style={Styles.spanAddress}>{`${item.query}`}</span>
                  {"   "}
                  <span
                    style={Styles.spanAddress2}
                  >{`Area: ${item.areaName}, Zone: ${item.zoneName}`}</span>
                </>
              ) : (
                item[optionLabelId]
              )}
            </Typography>
          ))}
        </Card>
      )}
    </div>
  );
}
